// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COMPLAINT_CANCEL = "Zru\u0161";
export const COMPLAINT_EXPLAIN_SIMPLE = "Nap\u00ed\u0161, \u010do nie je v poriadku a \u010do navrhuje\u0161:";
export const COMPLAINT_SUBMIT_TO_ADMINS = "Odo\u0161li Modr\u00fd kon\u00edk teamu";
export const COMPLAINT_SUBMIT_TO_GROUP_MODS = "Odo\u0161li moder\u00e1torom skupiny";
export const COMPLAINT_SUBMIT_TO_MODS = "Odo\u0161li moder\u00e1torom t\u00e9my";
